import '../styles/DateTimePicker.css'

interface DateTimePickerProps {
  startDate: Date | null
  duration: number
  onStartDateChange: (date: Date) => void
}

export function DateTimePicker({ startDate, duration, onStartDateChange }: DateTimePickerProps) {
  // Get tomorrow as minimum date
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  tomorrow.setHours(0, 0, 0, 0)

  // Calculate end date based on duration
  const endDate = startDate ? new Date(startDate.getTime() + duration * 24 * 60 * 60 * 1000) : null

  return (
    <div className="datetime-picker">
      <div className="date-inputs">
        <div className="date-input">
          <label>Дата начала аренды</label>
          <input
            type="date"
            value={startDate ? startDate.toISOString().split('T')[0] : ''}
            onChange={(e) => {
              const date = new Date(e.target.value)
              date.setHours(10, 0, 0, 0) // Set default time to 10:00
              onStartDateChange(date)
            }}
            min={tomorrow.toISOString().split('T')[0]}
          />
        </div>
        {startDate && (
          <div className="date-display">
            <span>Дата окончания: {endDate?.toLocaleDateString('ru-RU')}</span>
            <span className="duration-display">
              Длительность: {duration} {duration === 1 ? 'день' : 'дня'}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}